import { render, staticRenderFns } from "./SPRMessage.vue?vue&type=template&id=97c59360&scoped=true"
import script from "./SPRMessage.vue?vue&type=script&lang=js"
export * from "./SPRMessage.vue?vue&type=script&lang=js"
import style0 from "./SPRMessage.vue?vue&type=style&index=0&id=97c59360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c59360",
  null
  
)

export default component.exports